import { useMemo } from 'react';
import { useFastStore } from '../../context/FastContext';
export const useColumns = () => {
  const columns = useFastStore(store => store.columns);
  return useMemo(() => {
    return columns;
  }, [columns]);
};